import DatePicker from "react-datepicker"
import React, { Suspense, useState, useEffect } from "react";

export default function SingleDatePicker(param: any) {

    const [startDate, setStartDate] = useState<any>(null);

    const dataReceive = (e: any) => {
        setStartDate(e);
        param.onChange(e);
    };

    return (
        <div className="ws-12 pull-left">
            <div className="ws-12 pull-left">
                
                <DatePicker
                    placeholderText="Select Date"
                    selected={startDate}
                    onChange={(update: any) => {
                    dataReceive(update);
                    }}
                    isClearable={true}
                />
                
            </div>

        </div>
    );
}

